import { BottomSheetModal } from '@gorhom/bottom-sheet';
import { AccountDetailForSelector } from '@varo/graphql-schema-types';
import PayOverTimePaymentAccountRow from 'features/payOverTime/components/PayOverTimePaymentAccountRow/PayOverTimePaymentAccountRow';
import React, { Fragment, RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollView, StyleSheet, View } from 'react-native';
import BottomSheet from 'shared/components/vxl/BottomSheet/BottomSheet';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import theme from 'shared/styles/theme';

interface PayOverTimeAccountSelectionProps {
  bottomSheetRef: RefObject<BottomSheetModal | null> | null;
  paymentAccounts: AccountDetailForSelector[];
  onSelect: (acct: AccountDetailForSelector) => void;
}

const PayOverTimeAccountSelection = ({
  bottomSheetRef,
  paymentAccounts,
  onSelect,
}: PayOverTimeAccountSelectionProps) => {
  const { t } = useTranslation('payOverTime', { keyPrefix: 'manualRepay' });

  return (
    <BottomSheet ref={bottomSheetRef}>
      <ScrollView contentContainerStyle={styles.scrollContent}>
        <TitleMdText numberOfLines={1} style={styles.sheetTitle}>
          {t('paymentFrom')}
        </TitleMdText>
        <View style={styles.accountList}>
          {paymentAccounts &&
            paymentAccounts.map((acct) => {
              const isDisabled = !Number(acct.availableBalance.amount);
              return (
                <Fragment key={acct.accountId}>
                  <PayOverTimePaymentAccountRow
                    account={acct}
                    secondaryCopy={`${t('available')} ${acct.availableBalance.formattedWithPlusPrefix}`}
                    isDisabled={isDisabled}
                    onPress={() => onSelect(acct)}
                  />
                  <View style={styles.divider}>
                    <HairLineDivider />
                  </View>
                </Fragment>
              );
            })}
        </View>
      </ScrollView>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  accountList: {
    gap: theme.spacing.s,
    width: '100%',
  },
  divider: {
    paddingHorizontal: theme.spacing.m,
  },
  scrollContent: {
    flexGrow: 1,
    gap: theme.spacing.m,
  },
  sheetTitle: {
    paddingHorizontal: theme.spacing.m,
  },
});

export default PayOverTimeAccountSelection;
